import PropTypes from 'prop-types';
import { createContext, useEffect, useReducer } from 'react';
// utils
import jwtDecode from 'jwt-decode';
// import axios from '../utils/axios';
import { setSession } from '../utils/jwt';
import conObj from '../utils/connection-assistant';

// ----------------------------------------------------------------------

const extractUser = (accessToken) => {
  const { uname, username, uid, urole, defaultcurrency } = jwtDecode(accessToken);

  return { id: uid, username, displayName: uname, role: urole, defaultcurrency };
};

const initialState = {
  isAuthenticated: !!localStorage.getItem('accessToken'),
  isInitialized: false,
  user: null,
};

const handlers = {
  INITIALIZE: (state, action) => {
    const { isAuthenticated, user } = action.payload;
    return {
      ...state,
      isAuthenticated,
      isInitialized: true,
      user,
    };
  },
  LOGIN: (state, action) => {
    const { user } = action.payload;

    return {
      ...state,
      isAuthenticated: true,
      user,
    };
  },
  LOGOUT: (state) => ({
    ...state,
    isAuthenticated: false,
    user: null,
  }),
  REGISTER: (state, action) => {
    const { user } = action.payload;

    return {
      ...state,
      isAuthenticated: true,
      user,
    };
  },
};

const reducer = (state, action) => (handlers[action.type] ? handlers[action.type](state, action) : state);

const AuthContext = createContext({
  ...initialState,
  method: 'jwt',
  login: () => Promise.resolve(),
  logout: () => Promise.resolve(),
  register: () => Promise.resolve(),
});

// ----------------------------------------------------------------------

AuthProvider.propTypes = {
  children: PropTypes.node,
};

function AuthProvider({ children }) {
  const [state, dispatch] = useReducer(reducer, initialState);

  useEffect(() => {
    const initialize = async () => {
      try {
        const accessToken = localStorage.getItem('accessToken');

        // if (accessToken && isValidToken(accessToken)) {
        if (accessToken) {
          setSession(accessToken);

          const user = await getUserInfo(accessToken);

          console.log(user);

          dispatch({
            type: 'INITIALIZE',
            payload: {
              isAuthenticated: true,
              user,
            },
          });
        } else {
          dispatch({
            type: 'INITIALIZE',
            payload: {
              isAuthenticated: false,
              user: null,
            },
          });
        }
      } catch (err) {
        console.error(err);
        dispatch({
          type: 'INITIALIZE',
          payload: {
            isAuthenticated: false,
            user: null,
          },
        });
      }
    };

    initialize();
  }, []);

  const getUserInfo = async (jwt) => {
    const extractedJwt = extractUser(jwt);

    const { id, role, defaultcurrency, username, displayName } = extractedJwt;

    // const userRole = ['admin', 'subadmin'].includes(role) ? 'User' : 'Agent';

    // const { data } = await conObj.get(`/${userRole}`, { params: { userId: id } });

    return {
      id,
      defaultcurrency: defaultcurrency || 'USD',
      role,
      username,
      displayName,
      // username: data?.items[0]?.username,
      // displayName: data?.items[0].username,
      // name: data?.items[0].name,
      // phoneNumber: data?.items[0].phoneNumber,
      // isActive: data?.items[0].isActive,
    };
  };

  const login = async ({ userType, ...payload }) => {
    const loginUrlType = userType === 'sa' ? 'User' : 'Agent';

    const response = await conObj.post(`/${loginUrlType}/Login`, payload);

    const { jwt } = response.data;

    setSession(jwt);

    const user = await getUserInfo(jwt);

    dispatch({
      type: 'LOGIN',
      payload: {
        user,
      },
    });
  };

  const register = async (email, password, firstName, lastName) => {
    // const response = await axios.post('/api/account/register', {
    //   email,
    //   password,
    //   firstName,
    //   lastName,
    // });
    // const { accessToken, user } = response.data;

    const user = {
      email: 'demo@techero.co',
      firstName: 'demo',
      lastName: 'techero',
    };

    const accessToken = 'thisisjustasampleaccesstoken';

    localStorage.setItem('accessToken', accessToken);

    dispatch({
      type: 'REGISTER',
      payload: {
        user,
      },
    });
  };

  const logout = async () => {
    setSession(null);
    dispatch({ type: 'LOGOUT' });
  };

  return (
    <AuthContext.Provider
      value={{
        ...state,
        method: 'jwt',
        login,
        logout,
        register,
      }}
    >
      {children}
    </AuthContext.Provider>
  );
}

export { AuthContext, AuthProvider };
